"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
// Props should be kept for ts integration
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Tab(props) {
    return null;
}
exports.Tab = Tab;
Tab.displayName = '@mantine/core/Tab';
